<template>
    <div id="fastTasks">
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText">快速做任务</div>
            <div class="rule" @click="inFastTaskByLaws">细则</div>
        </div>
        <!-- 步骤流程 -->
        <div class="explain">
            <div class="explainPanel">
                <div class="public">
                    <img src="../assets/images/img_58.png" alt="">
                    <span>下载</span>
                </div>
                <img src="../assets/images/img_55.png" alt="" class="rightArrow">
                <div class="public">
                    <img src="../assets/images/img_57.png" alt="">
                    <span>试玩</span>
                </div>
                <img src="../assets/images/img_55.png" alt="" class="rightArrow">                
                <div class="public">
                    <img src="../assets/images/img_56.png" alt="">
                    <span>领奖</span>
                </div>
            </div>
        </div>
        <!-- 留存任务 -->
        <div class="hotRecommend" v-if=' isRemain.belongCount>0'>
            <div class="title">
                <div class="linesH"></div>
                <div class="fonts">留存任务</div>
                <div class="linesH"></div>
            </div>
            <div class="recommend">
                <div  class="head_tips_wrap" @click='openRemain'>
                    <div class="left_msg">
                        <img src="https://static.cattryapp.com/12static/new/img/head_crown.png" />
                        <div class="extratask_desc_wrap">
                        <p class="title_lg">留存任务</p>
                        <p class="title_num" >{{ isRemain.belongCount}}个进行中</p>
                        </div>
                    </div>
                    <p class="right_msg">
                        +{{isRemain.money}}<span>元</span>
                    </p>
            </div>
            </div>
        </div>
        <!-- 热门推荐 -->
        <div class="hotRecommend " :class="[ isRemain.belongCount>0 ?'styleHot':'']">
            <div class="title">
                <div class="linesH"></div>
                <div class="fonts">热门推荐</div>
                <div class="linesH"></div>
            </div>
            <div class="recommend" ref="tab">
                <ul class="content" ref="tabWrapper">
                    <li class="hotItem" @click="getRecomTask(item)" v-for="(item,indexs) in hotRecommend" :key="indexs" ref="tabitem">
                        <div class="img-wraper"><img :src="item.icon" alt=""></div>
                        <div>赚<span>{{item.tuser_price}}</span>元</div>
                    </li>
                </ul>
            </div>
            <div class="nothingTask" v-if="hotRecommend.length <= 0">
                {{currentTaskToast}}
            </div>
        </div>
        <!-- 当前任务 -->
        <div class="currentTasks currentMargin">
            <div class="title">
                <div class="linesR"></div>
                <div class="fonts">当前任务</div>
                <div class="linesR"></div>
            </div>
            <div class="taskItem" v-for="(item,index) in currentTasks" :key="index" @click="inMissionDetails(item)">
                <div class="taskItemLeft">
                    <div class="icons">
                        <img :src="item.icon" alt="">
                    </div>
                    <div class="centers">
                        <div class="taskTile">{{item.name}}</div>
                        <div class="others">
                            <span class="pay" v-if="item.ischarge == 1">付费</span>
                            <span v-else>免费</span>
                            <!-- <span>剩{{item.remaining_number}}份</span> -->
                            <span v-if="item.task_type == 'volume'">有剩余 <font color="#e6091a">截图</font></span>
                            <span v-else>有剩余</span>
                            <span v-if="item.task_type == 'fast' && item.has_belongtask==true"> <font color="#e6091a">留存</font></span>
                        </div>
                    </div>
                </div>
                <div class="taskItemRight">
                    <div class="tuserNum">+{{item.tuser_price}}<span>元</span></div>
                    <div v-if="item.ongoing" class="onging">进行中</div>
                </div>
            </div>
            <div class="nothingTask" v-if="currentTasks.length <= 0">
                {{currentTaskToast}}
            </div>
        </div>
        <!-- 联盟任务 暂时关闭-->
        <!-- <img src="../assets/images/img_71.png" alt="" id="unionTask" @click="inLeagueTask"> -->
        <!-- 任务预告 -->
        <div class="taskForecast forecastMargin">
            <div class="title">
                <div class="linesO"></div>
                <div class="fonts">任务预告</div>
                <div class="linesO"></div>
            </div>
            <div class="taskItem" v-for="(ite,ind) in taskForecast" :key="ind">
                <div class="taskItemLeft">
                    <div class="imgsDay imgsDayOne" v-if="ite.start_time.day == '今日'">
                        <span>{{ite.start_time.day}}</span>
                        <span>{{ite.start_time.time}}</span>
                    </div>
                    <div class="imgsDay imgsDayTwo" v-else-if="ite.start_time.day == '明日'">
                        <span>{{ite.start_time.day}}</span>
                        <span>{{ite.start_time.time}}</span>
                    </div>
                    <div class="imgsDay imgsDayThree" v-else-if="ite.start_time.day == '后日'">
                        <span>{{ite.start_time.day}}</span>
                        <span>{{ite.start_time.time}}</span>
                    </div>
                    <div class="centers">
                        <div class="taskTile">{{ite.name}}</div>
                        <div class="others">
                            <span class="pay" v-if="ite.ischarge == 1">付费</span>
                            <span v-else>免费</span>
                            <!-- <span>剩{{ite.remaining_number}}份</span> -->
                            <span>大量</span>
                        </div>
                    </div>
                </div>
                <div class="taskItemRight">
                    <div class="tuserNum">+{{ite.tuser_price}}<span>元</span></div>
                </div>
            </div>
            <div class="nothingTask" v-if="taskForecast.length <= 0">
                {{forecastTaskToast}}
            </div>
        </div>
        <!-- 邀请 -->
        <div class="invite" @click="inApprentice">想赚的更多？邀请好友 收徒赚钱~</div>


        <popup :pops='pops' @fatherMethod='fatherMethod' v-show="alreadyInstall"></popup>

    </div>
</template>

<script>
    // 引入弹窗
    import popup from '../components/Popup.vue';
    // 引入better-scroll插件
    import BScroll from "better-scroll";
    // 引入助手接口
    import clientApi from '../assets/js/clientApi.js';
    // 引入vant插件
    import { Dialog } from 'vant';

    export default {
        components:{
            popup,
        },
        data() {
            return {
                loadingShow:false, //加载中
                // 当前任务
                currentTasks:[],
                // 热门推荐
                hotRecommend:[],
                // 任务预告
                taskForecast:[],
                // 子组件配置
                pops:{
                    icons:require('../assets/images/img_77.png'), //可选
                    iconWidth:60, // 可选（若有图片必填）
                    iconHeight:60, // 可选（若有图片必填）
	                iconMargin:'13px 0 5px',
                    tits1:'您的设备已经下载过该应用', // 可选
                    // tits2:'快去分享给小伙伴吧', // 可选
                    // conts:'任务完成任务完成任务完成任务完成任务完成任务完成', // 可选
                    btns:'确定',
                    btnMarginTop:21
                },
                alreadyInstall:false,
                currentTaskToast: '正在加载当前任务中...',
                forecastTaskToast: '正在加载任务预告中...',

                helpBoundidData: [], // 苹果助手boundID列表
                is_ios11: true, // ios系统版本是否是11及以上
                isRemain:{
                    belongCount:0,
                    money:0
                } //是否显示留存任务--根据上面是不是有数据判断
            }
        },
        created() {
            this.init();
        },
        mounted() {
            
        },
        methods: {
            // 滑动弹回
            InitTabScroll() {
                let width = 0;
                for (let i = 0; i < this.hotRecommend.length; i++) {
                    console.log(this.$refs.tabitem[0].getBoundingClientRect())
                    width += this.$refs.tabitem[0].getBoundingClientRect().width; //getBoundingClientRect() 返回元素的大小及其相对于视口的位置
                }
                console.log(width);
                this.$refs.tabWrapper.style.width = width + "px";
                this.$nextTick(() => {
                    if (!this.scroll) {
                        this.scroll = new BScroll(this.$refs.tab, {
                            startX: 0,
                            click: true,
                            scrollX: true,
                            scrollY: false
                        });
                    } else {
                    this.scroll.refresh();
                    }
                });
            },
            // 初始化 发起请求
            init(){
                // this.$loading(true);

                // 获取苹果助手boundID列表
                let datas_id = {}
                this.$http.GETS('System/systemConfig',datas_id,(res)=>{
                    this.helpBoundidData = res.data.help_bound;
                });

                // 获取任务列表
                let datas = {}
                this.$http.GETS('fast_task/tasklist',datas,(res)=>{
                    this.$loading(false);
                    this.currentTasks = res.data.now_list;
                    const {belongCount} =res.data.belongTask
                    if( belongCount&&(belongCount > 0)){
                        this.isRemain = res.data.belongTask
                    }

                    if(Object.keys(res.data.tuser_now_task).length != 0){
                        res.data.tuser_now_task.ongoing = true;
                        this.currentTasks.unshift(res.data.tuser_now_task);
                    }
                    this.taskForecast = res.data.future_list;
                    this.hotRecommend = res.data.suggest_list;
                    this.is_ios11 = res.data.task_assistance.is_ios11;
                    this.currentTaskToast = '目前暂无任务，建议稍后刷新看看';
                    this.forecastTaskToast = '目前暂无任务预告，建议稍后刷新看看';

                    // 初始化热门推荐的scroll
                    this.$nextTick(() => {
                        this.InitTabScroll();
                    })
                });
            },
            // 返回首页
            returnPage:function(){
                this.$router.push('/');
            },
            // 推荐任务的抢任务逻辑
            getRecomTask(item) {
                console.log(item);
                switch(item.task_type) {
                    case 'fast': 
                        // 快速任务
                        this.inMissionDetails(item);
                        break;
                    case 'callback':
                        // 回调任务
                        this.inCallbackTaskOngoing(item.id);
                        break;
                    case 'volume':
                        // 高额任务
                        this.inHighTaskOngoing(item.task_id);
                        break;
                }
            },
            // 进入 快速任务-任务详情
            inMissionDetails:function(item){
                console.log(item);
                this.$loading(true);
                
                //6-10高额任务放在快速任务列表中
                if(item.task_type == 'volume') {
                    this.inHighTaskOngoing(item.task_id);
                    return ;
                }
                // 如果是进行的任务就不调用助手接口排重
                if(item.ongoing && item.ongoing == true) {
                    let datas = {
                        task_id:item.id
                    }
                    this.$http.POSTS('fast_task/starttask',datas,(res)=>{
                        if(item.putway == 9) {
                            this.$router.push({name:'reservationDetail',query: {ids:item.id}});
                            this.$loading(false);
                        }else{
                            this.$router.push({name:'missionDetails',query: {ids:item.id}});
                            this.$loading(false);
                        }
                    });
                    return;
                }

                this.checkAppHelper().then((res) => {
                    this.checkInstalled(item).then((res) => {
                        let datas = {
                            task_id:item.id
                        }
                        this.$http.POSTS('fast_task/starttask',datas,(res)=>{
                            if(item.putway == 9) {
                                this.$router.push({name:'reservationDetail',query: {ids:item.id}});
                                this.$loading(false);
                            }else{
                                this.$router.push({name:'missionDetails',query: {ids:item.id}});
                                this.$loading(false);
                            }
                        });
                    }).catch((err) => {
                        this.$loading(false);
                        Dialog.alert({title: '温馨提示', message: '对不起，该任务你已经做过，请抢其他任务吧'});
                    })
                }).catch((err) => {
                    this.$loading(false);
                    Dialog.alert({
                        message: err.msg
                    });
                })   
            },
            // 进入 回调任务进行中
            inCallbackTaskOngoing:function(ids){
                this.$loading(true);
                let datas = {
                    task_id:ids
                }
                this.$http.POSTS('callback_task/startTask',datas,(res)=>{
                    // console.log(res);
                    this.$loading(false);
                    this.$router.push({name:'callbackTaskOngoing',query: {ids:ids}});
                });
            },
            // 进入 高额任务进行页
            inHighTaskOngoing:function(ids){
                this.$loading(true);
                let datas = {
                    task_id:ids
                }
                this.$http.POSTS('volume_task/startTask',datas,(res)=>{
                    this.$loading(false);
                    console.log(res.data);
                    this.$router.push({name:'highTaskOngoing',query: {ids:ids}});
                });
            },
            // 进入 快速任务细则
            inFastTaskByLaws:function(){
                this.$router.push('/fastTasks/fastTaskByLaws')
            },
            // 进入 联盟任务
            inLeagueTask:function(){
                this.$router.push('/fastTasks/leagueTask')
            },
            // 进入 收徒赚钱
            inApprentice:function(){
                this.$router.push('/apprentice');
            },

            // 子组件方法
            fatherMethod:function(){
                this.alreadyInstall = false
                // this.$router.push('/');
            },

            // 抢任务前检测苹果助手
            checkAppHelper() {
                return new Promise((resolve, reject) => {
                    let _this = this;
                    if(this.is_ios11 == true){
                        if(this.helpBoundidData!=undefined){
                            //循环调用
                            (function loop_one(idx){
                                clientApi.ios11openurl({bundleid:_this.helpBoundidData[idx].bound_id})
                                .then( (response)=> {
                                    if (response.data == 1) {
                                        reject({code: 1, msg:'系统检测到本机内存在' + _this.helpBoundidData[idx].bound_name + '，请卸载后再抢任务！'});
                                    }else{
                                        if(idx < _this.helpBoundidData.length - 1){
                                            loop_one(++idx);
                                        }else{
                                            resolve();
                                        }
                                    }
                                }).catch(function (err) {
                                    console.log(err);
                                });
                            })(0)
                        }
                    }else {
                        clientApi.getlocalinstalledboundleid()
                        .then( (response)=> {
                            var apps=response.data;
                            if (apps != ''||apps!=undefined) {
                                let count = 0; //记录是否有助手
                                for (var i=0;i<apps.length;i++){
                                    for(var j=0;j<this.helpBoundidData.length;j++){
                                        if(this.helpBoundidData[j].bound_id==apps[i].app_identifier) {
                                            reject({code: 1, msg:'系统检测到本机内存在'+ this.helpBoundidData[j].bound_name +'，请卸载后再抢任务！'})
                                            count++;
                                            break;
                                        }
                                    }
                                    if(count > 0){
                                        break;
                                    }
                                }
                                if(count == 0){
                                    resolve();
                                }
                            }
                        }).catch(function (err) {
                            console.log(err);
                        });
                    }
                })
            },
            // 检测应用是否安装
            checkInstalled(task) {
                return new Promise((resolve, reject) => {
                    if(this.is_ios11 === true) {
                        clientApi.ios11openurl({bundleid: task.boundid}).then((response) => {
                            if(response.data == 1){
                                reject(); // 检测未通过，应用安装过
                            }else {
                                resolve(); // 检测通过，应用没安装过
                            }
                        }).catch((err) => {

                        });
                    }else {
                        clientApi.checktaskinstall(consts.V4installapp + "?bundleid=" + task.boundid).then((response) => {
                            if(response.status == 1) {
                                reject(); // 检测未通过，应用安装过
                            }else {
                                resolve(); // 检测通过，应用没安装过
                            }
                        }).catch((err) => {

                        })
                    }
                });
            },
            openRemain(){
                this.$router.push({
                    path: "/remain"
                });
            }
        },
    }
</script>

<style lang="less" scoped>
    #fastTasks{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
            .rule{
                font-size:15px;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 25px;
            }
        }

        // 步骤流程
        .explain{
            width: 375px;
            height: 58px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .explainPanel{
                width:245px;
                height:50px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,.5);
                margin: 0px 15px;
                position: relative;
                top: 8px;
                padding: 25px 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .public{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    img{
                        width: 26px;
                        height: 26px;
                    }
                    span{
                        margin-top: 6px;
                        font-size: 15px;
                        color: #151515;
                        font-weight: bold;
                    }
                }
                .rightArrow{
                    width: 30px;
                    height: 17px;
                }
            }
        }

        // 当前任务 任务预告
        .currentMargin{
            margin: 13px 15px 17px;
        }
        .forecastMargin{
            margin: 0 15px;
        }
        .currentTasks,.taskForecast{
            width:345px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,.5);
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 23px 0 30px;
                .linesR{
                    width:10px;
                    height:3px;
                    background:rgba(229,1,19,1);
                    border-radius:2px;
                }
                .linesO{
                    width:10px;
                    height:3px;
                    background:rgba(255,146,11,1);
                    border-radius:2px;
                }
                .fonts{
                    font-size:15px;
                    color:rgba(21,21,21,1);
                    line-height:15px;
                    font-weight: bold;
                    margin: 0 5px;
                }
            }
            .taskItem{
                margin: 0 15px 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .taskItemLeft{
                    display: flex;
                    align-items: center;
                    .icons{
                        width:60px;
                        height:60px;
                        overflow: hidden;
                        border-radius: 8px;
                        img{
                            width: 60px;
                            height: 60px;
                            border-radius: 12px;
                            filter: blur(12px);
                        }
                    }
                    .imgsDay{
                        width:60px;
                        height:60px;
                        border-radius:11px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        span{
                            font-size:13px;
                            color:rgba(255,255,255,1);
                            line-height:13px;
                            font-weight: bold;
                            &:first-of-type{
                                margin-bottom: 6px;
                            }
                        }
                    }
                    .imgsDayOne{
                        background:linear-gradient(319deg,rgba(255,38,96,1) 0%,rgba(255,181,47,1) 100%);
                    }
                    .imgsDayTwo{
                        background:linear-gradient(315deg,rgba(255,68,131,1) 0%,rgba(255,134,134,1) 100%);
                    }
                    .imgsDayThree{
                        background:linear-gradient(312deg,rgba(243,143,31,1) 0%,rgba(255,159,52,1) 100%);
                    }
                    .centers{
                        height: 60px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        padding: 0 15px;
                        .taskTile{
                            font-size:16px;
                            color:rgba(21,21,21,1);
                            line-height:16px;
                        }
                        .others{
                            span{
                                display: inline-block;
                                padding: 5px 13px;
                                border-radius:12px;
                                border:1px solid rgba(229,229,229,1);
                                font-size:12px;
                                color:rgba(153,153,153,1);
                                line-height:12px;
                                &:last-of-type{
                                    margin-left: 10px;
                                }
                            }
                            .pay{
                                background:rgba(255,227,227,1);
                                border:1px solid rgba(243,75,88,1);
                                color: #E50113;
                            }
                        }
                    }
                }
                .taskItemRight{
                    // height: 100%;
                    font-size:20px;
                    font-weight: bold;
                    color:rgba(230,9,26,1);
                    line-height:24px;
                    white-space: nowrap;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .tuserNum{
                        font-family: "Qds";
                        span{
                            font-size: 14px;
                            font-weight: normal;
                        }
                    }
                    .onging{
                        color: #08A1F8;
                        font-size: 14px;
                        text-align: center;
                    }
                }
            }
            .nothingTask{
                margin: 25px 0;
                font-size:16px;
                color:rgba(153,153,153,1);
                line-height:11px;
                text-align: center;
            }
        }

        // 热门推荐
        .hotRecommend{
            width:315px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,.5);
            margin: 65px 15px 0;
            padding: 0 15px 15px;
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 23px 0 30px;
                .linesH{
                    width:10px;
                    height:3px;
                    background:#ff4483;
                    border-radius:2px;
                }
                .fonts{
                    font-size:15px;
                    color:rgba(21,21,21,1);
                    line-height:15px;
                    font-weight: bold;
                    margin: 0 5px;
                }
            }
            .recommend{
                overflow: hidden;
                .content{
                    width: 100%;
                    display: flex;
                    .hotItem{
                        padding: 0 15px;
                        .img-wraper {
                            width: 60px;
                            height: 60px;
                            overflow: hidden;
                            border-radius: 8px;
                        }
                        img{
                            width: 60px;
                            height: 60px;
                            border-radius: 8px;
                            filter: blur(12px);
                        }
                        div{
                            text-align: center;
                            span{
                                font-size:20px;
                                font-family: "Qds";
                            }
                        }
                        // &:first-of-type{
                        //     padding-left: 0px;
                        // }
                        // &:last-of-type{
                        //     padding-right: 0px;
                        // }
                    }
                }
            }
            .nothingTask{
                margin: 0 0 25px;
                font-size:16px;
                color:rgba(153,153,153,1);
                line-height:11px;
                text-align: center;
            }
        }
        .styleHot {
            margin-top:0.34667rem;
        }

        // 联盟任务
        #unionTask{
            width:345px;
            height:68px;
            margin: 0 15px 17px;
        }

        // 邀请
        .invite{
            padding: 25px 0;
            font-size:11px;
            color:rgba(153,153,153,1);
            line-height:11px;
            text-decoration: underline;
            text-align: center;
        }
        .head_tips_wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid #ececec;
             .left_msg{
                 display: flex;
                 align-items: center;
                 img {
                 width: 45px;
                 height: 44px;
                 margin-right: 10px;
             }
             .title_lg{
                font-size: 16px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: #333;
                line-height: 22px;
                margin-bottom: 5px;
             }
             .title_num {
                font-size: 12px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: #5192f5;
                line-height: 16px;
             }
             }
             .right_msg {
                font-size: 20px;
                font-family: HelveticaNeue-Medium;
                font-weight: 500;
                color: #ff6353;
                line-height: 27px;
                span {
                    font-size: 14px;
                    margin-left: 5px;
                }
             }
        }
    }
</style>